<template>
  <div v-if="images.length" :class="['social-gallery', `social-gallery--${Math.min(images.length, 4)}`]">
    <button v-for="(image, index) in images" :key="image.id" type="button" @click="$emit('open', index)">
      <img :src="mediaUrl(image.url)" :alt="`Imagem ${index + 1} da publicação`" :loading="lazy ? 'lazy' : 'eager'">
    </button>
  </div>
</template>
<script>
import { socialMediaUrl } from "@/server/SocialService";
export default { name: "SocialPostGallery", props: { images: { type: Array, default: () => [] }, lazy: { type: Boolean, default: true } }, methods: { mediaUrl: socialMediaUrl } };
</script>
